<ng-container *ngIf="optionDesign === 'Text outside the box'">
  <div class="color" [ngStyle]="{'backgroundColor': color}" *ngIf="colorEnabled"></div>
  <div class="name" [title]="text">{{ text ? text : emptyText }}</div>
</ng-container>

<ng-container *ngIf="optionDesign !== 'Text outside the box'">
  <div class="color-background" [ngStyle]="{'backgroundColor': color}" *ngIf="colorEnabled && text">
    <div class="name" [title]="text" [ngStyle]="{'color': textColor}">{{ text }}</div>
  </div>
  <div class="not-set" *ngIf="colorEnabled && !text">
    <div class="name">{{ emptyText }}</div>
  </div>
</ng-container>